import ReactDOM from 'react-dom';
import NativePortal from './NativePortal';
import CustomPortal from './CustomPortal';

// eslint-disable-next-line import/no-mutable-exports
var Component = CustomPortal;

if (ReactDOM.createPortal) {
  Component = NativePortal;
}

export default Component;